import "./css/Hero.css";
import spotlight from "../images/spotlight.png";

function Hero() {
  return (
      <img src={spotlight} alt="Spotlight" className="spotlight" />
  );
}

export default Hero;
